let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7mPOF")).then(() => parcelRequire('b1t6C'));